
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iFaMg", function(module, exports) {

$parcel$export(module.exports, "ELEMENTS_NOT_IN_NAV", () => $2834702a20a1816a$export$d34bba8c7068f876);
$parcel$export(module.exports, "autoAdjustPosition", () => $2834702a20a1816a$export$8005c110df91a313);
$parcel$export(module.exports, "OnboardingNudgeComponent", () => $2834702a20a1816a$export$96dfbdc3eda1cd3a);
$parcel$export(module.exports, "OnboardingNudge", () => $2834702a20a1816a$export$c09847f3a2ea8c56);

var $gwFzn = parcelRequire("gwFzn");

var $gR84W = parcelRequire("gR84W");

var $dTk3A = parcelRequire("dTk3A");

var $inPa6 = parcelRequire("inPa6");

var $7Sm4c = parcelRequire("7Sm4c");

var $gfIPU = parcelRequire("gfIPU");
var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $dIouf = parcelRequire("dIouf");

var $id4ij = parcelRequire("id4ij");

var $huBE1 = parcelRequire("huBE1");
const $2834702a20a1816a$export$d34bba8c7068f876 = {};
const $2834702a20a1816a$export$8005c110df91a313 = (fn, { interval: interval = 500, cycles: cycles = 10 })=>{
    let i = 0;
    const timer = setInterval(()=>{
        fn?.();
        i++;
        if (i === cycles) clearInterval(timer);
    }, interval);
    return timer;
};
function $2834702a20a1816a$var$isErrorHandled(error) {
    // Mark unauthorized error as handled and not report to monitoring client
    if ((0, $dIouf.isUnauthorizedError)(error) || error?.graphQLErrors?.[0]?.message === 'unauthorized') {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    return false;
}
const $2834702a20a1816a$export$96dfbdc3eda1cd3a = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { hidden: hidden, children: children, source: source, actionSubjectId: actionSubjectId, heading: heading, content: content, width: width = 320, wrapper: wrapper, zIndex: zIndex = (0, $dTk3A.layers).blanket(), position: position, offset: offset, onShow: onShow, onHide: onHide, onClick: onClick, onOutsideClick: onOutsideClick, onboardingErrors: onboardingErrors } = props;
    const Wrapper = wrapper || (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment;
    const target = `onboarding-nudge-${actionSubjectId}`;
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const nudgeSpotlightRef = (0, $gwFzn.useRef)(null);
    // used to turn off effects for outsideClick
    const [outsideClicked, setOutsideClicked] = (0, $gwFzn.useState)(false);
    /**
	 * The point of this local hidden is to hide the nudge when the element is no longer in view
	 * This local hidden value is then changed when the element is back in view.
	 */ const [isLocalHidden, setIsLocalHidden] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (!hidden) experienceTracker.start({
            name: (0, $irVI7.ONBOARDING_NUDGE_EXPERIENCE)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hidden,
        experienceTracker
    ]);
    // Scroll fix for nudges that will be covered by global nav
    (0, $gwFzn.useEffect)(()=>{
        let isScrolling;
        const handleMouse = ()=>{
            isScrolling && window.clearTimeout(isScrolling);
            isScrolling = setTimeout(()=>{
                const element = document.getElementById(target);
                if (!element) return;
                let elementInViewport = (0, $id4ij.isElementInViewport)(element);
                // Elements not in the nav bar sometimes get hidden by the nav bar
                elementInViewport = element.getBoundingClientRect().top > 40;
                setIsLocalHidden(!elementInViewport);
            }, 250);
        };
        if (!hidden) window.addEventListener('scroll', handleMouse, true);
        return ()=>{
            window.removeEventListener('scroll', handleMouse, true);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hidden,
        outsideClicked
    ]);
    // Timer to account for lazily loaded components and to update tooltip position with a force rerender
    (0, $gwFzn.useEffect)(()=>{
        let timer;
        if (!hidden && nudgeSpotlightRef && nudgeSpotlightRef.current) timer = $2834702a20a1816a$export$8005c110df91a313(nudgeSpotlightRef?.current?.forceUpdateCardPosition, {
            interval: 500,
            cycles: 10
        });
        return ()=>{
            clearInterval(timer);
        };
    }, [
        nudgeSpotlightRef,
        hidden
    ]);
    // ------ Behavioral Callbacks ------
    const handleOnHide = ()=>{
        (0, $huBE1.fireEvent)(createAnalyticsEvent, {
            type: 'sendTrackEvent',
            source: source,
            actionSubjectId: actionSubjectId,
            actionSubject: 'nudgeTooltip',
            action: 'hidden'
        });
        onHide?.();
    };
    const handleOnClick = ()=>{
        (0, $huBE1.fireEvent)(createAnalyticsEvent, {
            type: 'sendTrackEvent',
            source: source,
            actionSubjectId: actionSubjectId,
            actionSubject: 'nudgeTooltip',
            action: 'clicked'
        });
        onClick?.();
        experienceTracker.succeed({
            name: (0, $irVI7.ONBOARDING_NUDGE_EXPERIENCE)
        });
    };
    const handleOnShow = ()=>{
        (0, $huBE1.fireEvent)(createAnalyticsEvent, {
            type: 'sendTrackEvent',
            source: source,
            actionSubjectId: actionSubjectId,
            actionSubject: 'nudgeTooltip',
            action: 'shown'
        });
        onShow?.();
    };
    const handleOnOutsideClick = ()=>{
        onOutsideClick?.();
        setOutsideClicked(true);
    };
    // If there is a known error it should not display the nudge the priority of error is higher than hidden
    if (onboardingErrors && onboardingErrors.length) {
        const ErrorDisplays = onboardingErrors.filter((error)=>{
            return !$2834702a20a1816a$var$isErrorHandled(error);
        }).map((error)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
                error: error,
                key: error.message
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gfIPU.ExperienceFailure), {
                name: (0, $irVI7.ONBOARDING_NUDGE_EXPERIENCE),
                error: error,
                key: error.message,
                attributes: {
                    source: source,
                    actionSubjectId: actionSubjectId
                }
            }));
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children, ErrorDisplays);
    }
    return hidden || isLocalHidden ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gR84W.NudgeSpotlight), {
        ...props,
        ref: nudgeSpotlightRef,
        heading: heading,
        content: content,
        width: width,
        hidden: hidden || isLocalHidden,
        hideNudgeOnClick: true,
        hideSpotlightCardOnOutsideClick: true,
        onHide: handleOnHide,
        onShow: handleOnShow,
        onClick: handleOnClick,
        onOutsideClick: handleOnOutsideClick,
        zIndex: zIndex,
        position: position,
        offset: offset
    }, children));
};
const $2834702a20a1816a$export$c09847f3a2ea8c56 = (props)=>{
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const failedOnboardingNudge = (0, $gwFzn.useCallback)((error)=>{
        experienceTracker.fail({
            name: (0, $irVI7.ONBOARDING_NUDGE_EXPERIENCE),
            error: error
        });
    }, [
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.GenericErrorBoundary), {
        attribution: (0, $dIouf.Attribution).FLYWHEEL_ADOPTION,
        onError: failedOnboardingNudge,
        renderOnError: ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, props.children);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($2834702a20a1816a$export$96dfbdc3eda1cd3a, props));
};

});
parcelRegister("huBE1", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $a1b66a9372b16102$export$43835e9acf248a15);
const $a1b66a9372b16102$var$COMPONENT_NAME = 'nudgeTooltip';
const $a1b66a9372b16102$export$43835e9acf248a15 = (createAnalyticsEvent, { contentId: contentId, actionSubjectId: actionSubjectId, actionSubject: actionSubject, source: source, action: action, type: type, attributes: attributes })=>{
    createAnalyticsEvent({
        type: type,
        data: {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            source: source,
            attributes: {
                ...contentId ? {
                    contentId: contentId
                } : {},
                nudgeTarget: actionSubjectId,
                componentName: $a1b66a9372b16102$var$COMPONENT_NAME,
                ...attributes
            }
        }
    }).fire();
};

});



//# sourceMappingURL=OnboardingNudgeTooltip.37350f7f.js.map
